<template>
  <div>
    <div class="pb-6 text-center">
      <h1
        class="text-ontick-steel-900 text-2xl font-semibold dark:text-gray-200"
      >
        {{ data.strategy_name }}
      </h1>
      <p class="font-regular text-ontick-steel-700 text-sm dark:text-gray-300">
        Ativo operado {{ data.strategy_symbol }}
      </p>
    </div>

    <div class="flex justify-center space-x-2 pb-6">
      <div class="h-6 w-6" v-html="itemLogo(selectedAccount.broker_name)"></div>
      <p class="text-ontick-steel-900 text-lg font-semibold dark:text-gray-200">
        {{ selectedAccount.broker_name }}
      </p>
      <p class="text-ontick-steel-400 text-lg font-medium dark:text-gray-400">
        (#{{ selectedAccount.account_number }})
      </p>
      <ontick-account-type-badge-component
        :accountType="selectedAccount.account_type"
      />
    </div>
  </div>
</template>

<script>
import ontickAccountTypeBadgeComponent from "../../../../../../shared/components/basic/ontick-account-type-badge.component.vue";

export default {
  components: {
    ontickAccountTypeBadgeComponent,
  },

  props: {
    selectedAccount: { type: Object },
    data: { type: Object },
  },

  methods: {
    itemLogo(value) {
      let img;
      if (value == "OnTick") {
        img = this.$icons.ontick;
      } else if (value == "XP") {
        img = this.$icons.xp;
      } else if (value == "Cripto") {
        img = this.$icons.bitcoin;
      }
      return img;
    },
  },
};
</script>

<style></style>
